import { useHistory, useLocation } from 'react-router-dom';

import React from 'react';
import { useInteractionTracker } from '@blueshift-ui/telemetry';

//

function useSubjectNavigationSection({ activeStudentId, addSubjectLink }) {
  const { trackEvent } = useInteractionTracker();

  const history = useHistory();
  const location = useLocation();

  //
  // State

  const [editMode, setEditMode] = React.useState(false);
  const [deletedSubjectIds, setDeletedSubjectIds] = React.useState([]);

  //
  // Event handlers

  function handleDeletedSubject(action, subjectId) {
    trackEvent({
      action: `${action}-subject`,
      category: 'side-nav',
      label: `subject-id-${subjectId}`,
    });

    if (location.pathname.includes(subjectId)) {
      history.push(addSubjectLink);
    }

    setDeletedSubjectIds((deletedIds) => {
      const index = deletedIds.indexOf(subjectId);

      if (index >= 0) {
        deletedIds.splice(index, 1);
        deletedIds = [...deletedIds];
      }

      return deletedIds;
    });
  }

  function handleDeletingSubject(subjectId) {
    setDeletedSubjectIds((subjectIds) => [...subjectIds, subjectId]);
  }

  function handleEditModeToggle() {
    setEditMode((mode) => {
      trackEvent({
        action: mode ? 'exit-edit-mode' : 'enter-edit-mode',
        category: 'side-nav',
      });

      return !mode;
    });
  }

  function handleFailedToDeleteSubject(subjectId) {
    setDeletedSubjectIds((subjectIds) => subjectIds.filter((id) => id !== subjectId));
  }

  //
  // Side Effects

  React.useEffect(
    function _turnOffEditModeAfterStudentSwitch() {
      setEditMode(false);
    },
    [activeStudentId]
  );

  //
  // Result

  return {
    deletedSubjectIds,
    editMode,
    handleDeletedSubject,
    handleDeletingSubject,
    handleEditModeToggle,
    handleFailedToDeleteSubject,
  };
}

// Exports
// -------

export default useSubjectNavigationSection;
